<template>
    <cp-grid class="modal-content" v-bind:class="{ 'no-padding': modalFeed }">
        <cp-grid-item :span="12">
            <div>
              <svg
                  @click.prevent="dismissModal"
                  class="close-svg-icon"
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
              >
                  <path
                      d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                  ></path>
              </svg>
              <p class="heading-1 form-heading">Attach GIF</p>
            </div>
            <div>
                <input class="form-search" :value="query" @input="evt => (query = evt.target.value)" @keyup="searchGifs" placeholder="Search" type="text" />
            </div>
        </cp-grid-item>
        <cp-grid-item :span="12" v-if="gifsSearch && gifsSearch.length > 0">
            <transition name="fade" mode="out-in">
                <transition-group name="feed-fade">
                    <cp-listing-gif :gifs="gifsSearch" key="search" :dismissModal="dismissModal" :selectedGif="selectedGif"></cp-listing-gif>
                </transition-group>
            </transition>
        </cp-grid-item>
        <cp-grid-item :span="12" v-else-if="gifsSearch && gifsSearch.length == 0 && query.length > 0">
            <span class="heading-1 form-heading">No matches found</span>
        </cp-grid-item>
        <cp-grid-item :span="12">
            <div style="margin-bottom: 10px;">
                <span class="heading-1 form-heading">Trending GIFS</span>
            </div>
            <div>
                <transition name="fade" mode="out-in">
                    <div>
                        <transition-group name="feed-fade">
                            <cp-listing-gif :gifs="gifsTrending" key="trending" :dismissModal="dismissModal" :selectedGif="selectedGif"></cp-listing-gif>
                        </transition-group>
                    </div>
                </transition>
            </div>
            <div>
                <p class="heading-4 form-heading" style="color: black; font-size: 20px; margin-bottom: 0;">
                    Powered by
                    <cp-base-svg-icon :width="60" :height="18" :viewBox="'0 0 1305 400'" style="vertical-align: middle;">
                        <giphy-icon />
                    </cp-base-svg-icon>
                </p>
            </div>
        </cp-grid-item>
    </cp-grid>
</template>

<script>
import CpTextInput from '../inputs/text';

export default {
    name: 'CpModalGifs',
    data() {
        return {
            apiUrl: process.env.MIX_GIPHY_API_URL,
            apiKey: process.env.MIX_GIPHY_API_KEY,
            gifsTrending: null,
            gifsSearch: null,
            query: ''
        };
    },
    props: {
        selectedGif: Function,
        modalFeed: { type: Boolean, default: false },
    },
    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop
    },
    components: {
        CpButton: require('../button'),
        CpListingGif: require('./listing-gif').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
        GiphyIcon: require('../social-feed/icons/giphy').default,
        CpGrid: require('../grid').default,
        CpGridItem: require('../grid-item').default,
    },
    methods: {
        dismissModal() {
            this.$emit('close');
        },
        fetchGifs() {
            const url = `${this.apiUrl}trending?api_key=${this.apiKey}&limit=4&rating=g&lang=en`;
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(response => {
                    this.gifsTrending = response.data;
                });
        },
        searchGifs() {
            this.loading = true;
            const url = `${this.apiUrl}search?api_key=${this.apiKey}&q=${this.query}&limit=8&rating=g&lang=en`;
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(response => {
                    this.gifsSearch = response.data;
                });
        }
    },
    created() {
        this.fetchGifs();
    }
};
</script>

<style scoped>
.no-padding {
    padding: 0 !important;
}
.form-search {
    display: flex;
    height: 40px;
    background: white;
    flex-grow: 1;
    font: inherit;
    width: 100%;
}
.modal-content {
    padding: 20px 40px;
    text-align: center;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {

}
@media only screen and (max-width: 767px) {

}
/* transition styles */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
